export const OFFER_VALIDITY_PERIOD = [6, 12, 24, 48];

export const moveInTypes = {
  ANYTIME: 'ANYTIME',
  AFTER: 'AFTER',
  EXACTLY_MATCH: 'EXACTLY_MATCH',
};

export const moveOutTypes = {
  ANYTIME: 'ANYTIME',
  BEFORE: 'BEFORE',
  EXACTLY_MATCH: 'EXACTLY_MATCH',
};

export const tenancyLengthTypes = {
  EQUALS: 'EQUALS',
  NO_LESS_THAN: 'NO_LESS_THAN',
  NO_MORE_THAN: 'NO_MORE_THAN',
  BETWEEN: 'BETWEEN',
  NOT_SPECIFIC: 'NOT_SPECIFIC',
};

export const instalmentPlanMap = {
  FULL_PAYMENT: 'fullPayment',
  PAY_REMAINDER_AT_ONCE: 'payRemainderAtOnce',
  PAY_WEEKLY: 'payWeekly',
  PAY_MONTHLY: 'payMonthly',
  PAY_QUARTERLY: 'payQuarterly',
};

export const getTenancyValues = (tenancyLengthType, tenancyLengthValue) => {
  let tenancyFrom = null;
  let tenancyEnd = null;
  if (tenancyLengthType === tenancyLengthTypes.BETWEEN) {
    [tenancyFrom, tenancyEnd] =
      tenancyLengthValue.indexOf('-') !== -1
        ? tenancyLengthValue.split('-')
        : tenancyLengthValue.split('_');
  } else if (tenancyLengthType === tenancyLengthTypes.EQUALS) {
    tenancyFrom = tenancyLengthValue;
    tenancyEnd = tenancyLengthValue;
  } else if (tenancyLengthType === tenancyLengthTypes.NO_LESS_THAN) {
    tenancyFrom = tenancyLengthValue;
    tenancyEnd = null;
  } else if (tenancyLengthType === tenancyLengthTypes.NO_MORE_THAN) {
    tenancyFrom = 0;
    tenancyEnd = tenancyLengthValue;
  }

  return { tenancyFrom, tenancyEnd };
};
